export default __webpack_public_path__ + "static/media/empty_cart.378125a8.svg";